import { useState } from "react"

export const useEmailVerification = () =>{
     const [error] = useState("")


         const verifyEmail = async(emailToken) =>{

            const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/verify-email`, {
                method: 'POST',
                headers: {'Content-Type':'application/json'
            },
                body: JSON.stringify({emailToken})
            })
            const json = await response.json()

            if(response.status === 400){
           return json;
            }
            if(response.ok){
                return json;
            }
        

        

         }

         return {verifyEmail, error}
}

